@if (!isLoading() && montageplanTeamDtos() && montageplanTeamDtos().length) {
  <div class="work-ui-montageplan-day-overview">
    <div class="work-ui-montageplan-day-overview__day">
      <h2>{{ date() | formatDate:'dd' }}, {{ date() | formatDate }}</h2>
    </div>
    <div class="work-ui-montageplan-day-overview__content">
      <div class="work-ui-montageplan-day-overview__teams">
        @for (teamDto of montageplanTeamDtos(); track teamDto) {
          <div
            [class.work-ui-montageplan-day-overview__team--disabled]="isEntireTeamAbsent(teamMembers().teams[teamDto.teamId], date())"
            class="work-ui-montageplan-day-overview__team work-card"
          >
            <div class="work-ui-montageplan-day-overview__team-header">
              <h1 class="work-ui-montageplan-day-overview__team-header-heading">{{ teamDto.team }}</h1>
              <div class="work-ui-montageplan-day-overview__team-members">
                @for (member of teamMembers().teams[teamDto.teamId]; track member) {
                  @if (member && member.user) {
                    @let timerecordtypeName = (member.timerecords && member.timerecords[date()] && member.timerecords[date()].timerecordtypeName) ? member.timerecords[date()].timerecordtypeName : '';
                    @let timerecordIsTeamLead = (member.timerecords && member.timerecords[date()] && member.timerecords[date()].isTeamLead);
                    @let timerecordhasBirthday = (member.timerecords && member.timerecords[date()] && member.timerecords[date()].hasBirthday);
                    @let timerecordNote = canEditNotes() && member.timerecords && member.timerecords[date()] ? member.timerecords[date()].montageplanNote : null;
                    @let status = timerecordtypeName && timerecordtypeName === WorkTimerecordtypeNameEnum.Arbeit ? 'available' : 'absent';
                    <div class="work-ui-montageplan-day-overview__team-member"
                         [class.is-team-lead]="timerecordIsTeamLead"
                         [class.has-birthday]="timerecordhasBirthday"
                         (click)="openUserDetails.emit(member.userId)">
                      <work-ui-avatar
                        [imgSrc]="member.user.userImage ? (member.user.userImage.fileSrcThumbnail | prependServerToFileSrc) : null"
                        [initials]="member.user.firstName.substring(0,1)+member.user.lastName.substring(0,1)"
                        [status]="status"
                        [title]="member.user.firstName + ' ' + member.user.lastName"
                        size="small" />
                      <span class="flex flex-column">
                        <span>{{ member.user.firstName }} {{ member.user.lastName }}</span>
                        @if (timerecordNote) {
                          <small class="work-text-color-light work-ui-montageplan-day-overview__team-member-note"><b>{{ 'NOTIZ' | translate }}:</b> {{ timerecordNote }}</small>
                        }
                      </span>
                      @if (canEditNotes() && member.timerecords && member.timerecords[date()]) {
                        <work-ui-button (buttonClick)="openNoteModal(member)"
                                        [iconOnly]="true"
                                        [stopPropagation]="true"
                                        [title]="(timerecordNote ? 'NOTIZ' : 'MONTAGEPLAN_NOTIZ_HINZUFUEGEN') | translate"
                                        class="work-ui-montageplan-day-overview__team-member-action"
                                        [iconName]="timerecordNote ? 'sticky_note_2' : 'note_add'"
                                        size="small"
                                        variant="tertiary" />
                      }
                      @if (canChangeTeamOfMember()) {
                        <work-ui-button (buttonClick)="openChangeTeamModal(member.userId, member.user.firstName + ' ' + member.user.lastName, teamDto.teamId)"
                                        [iconOnly]="true"
                                        [stopPropagation]="true"
                                        class="work-ui-montageplan-day-overview__team-member-action"
                                        iconName="swap_horiz"
                                        size="small"
                                        variant="tertiary" />
                      }
                    </div>
                  }
                }
              </div>
            </div>
            <div class="work-ui-montageplan-day-overview__team-projects">
              @for (block of teamDto.blocks; track block) {
                <div class="work-ui-montageplan-day-overview__team-project"
                     [class.work-card--is-clickable]="!!block.projectId"
                     (click)="block.projectId ? openProjectDetails.emit(block.projectId) : undefined">
                  @if (block.taskName) {
                    <small class="work-text-color-light">{{ block.taskName }}</small>
                  }
                  <p>{{ block.projectName }}</p>
                  @if (showObjectAddressInsteadOfCustomer()) {
                    <h5>{{ block.projectStreet }}, {{ block.projectZipCode }} {{ block.projectCity }}</h5>
                  } @else {
                    <h5>{{ block.customerName }}</h5>
                  }
                </div>
              }
            </div>
            @if (teamDto.tasks && teamDto.tasks.length) {
              <div class="work-ui-montageplan-day-overview__team-tasks">
                @for (task of teamDto.tasks; track task) {
                  <div class="work-ui-montageplan-day-overview__team-task"
                       [class.work-card--is-clickable]="!!task.projectId"
                       (click)="task.projectId ? openProjectDetails.emit(task.projectId) : undefined">
                    <work-ui-button [iconOnly]="true"
                                    iconName="checklist"
                                    size="small"
                                    variant="primary" />
                    <p>
                      @if ((task.start | formatDate:'HH:mm') !== '00:00') {
                        <b>{{ task.start | formatDate:'HH:mm' }} - </b>
                      }
                      @if (task.project) {
                        <span>{{ task.project.numberQualified }}: </span>
                      }{{ task.name }}@if (task.status) {
                      <span> ({{ task.status | translate }})</span>
                    }
                    </p>
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>
}

<work-ui-modal #changeTeamModal
               (modalClosedWithNoButton)="memberToChangeTeam.set(undefined)"
               [noFooter]="true"
               [titleText]="'TEAM_WECHSELN' | translate"
               modalId="montageplanDayOverviewChangeTeamModal">
  <ng-container modal-body>
    @if (changeTeamModal.isOpen && memberToChangeTeam(); as member) {
      <p class="margin-bottom-16">{{ 'TEAM_WECHSELN_HINWEIS' | translate:{ name: member.name, date: (date() | formatDate) } }}</p>
      <div class="work-ui-montageplan-day-overview__change-team-list">
        @for (targetTeam of changeTeamTargetTeams(); track targetTeam.teamId) {
          <work-ui-button (buttonClick)="changeTeamOfMember(targetTeam.teamId)"
                          [disabled]="changeTeamLoadingState() === 'loading'"
                          [text]="targetTeam.team"
                          iconName="group"
                          variant="secondary" />
        }
      </div>
    }
  </ng-container>
</work-ui-modal>

@if (showMontageplanNotes()) {
  <work-ui-montageplan-note-modal #montageplanNoteModal (noteSaved)="onNoteSaved($event)" />
}
